/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function parseJSON(response) {
  return response.json();
}
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  var error = new Error(response.statusText);
  error.response = response;
  throw error;
}
function request(url, options) {
  return fetch(url, options).then(checkStatus).then(parseJSON).then(function (data) {
    return {
      data: data
    };
  }).catch(function (err) {
    return {
      err: err
    };
  });
}
function _post(url, payload) {
  var headers = {};
  headers['Content-Type'] = 'application/x-www-form-urlencoded';
  var formBody = Object.keys(payload).map(function (key) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(payload[key]));
  }).join('&');
  return request(url, {
    method: 'POST',
    headers: headers,
    body: formBody,
    credentials: 'omit'
  });
}
function post(url, payload) {
  return __awaiter(this, void 0, void 0, function () {
    var _a, data, err;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4, _post(url, payload)];
        case 1:
          _a = _b.sent(), data = _a.data, err = _a.err;
          if (err) {
            throw err;
          }
          if (data && data.code === 0) {
            return [2, data.data];
          } else {
            throw new Error(data === null || data === void 0 ? void 0 : data.message);
          }
      }
    });
  });
}

var HOST = {
  'prod': 'https://i18n.mykeeta.com',
  'test': 'https://i18n.mykeeta.com',
  'dev': 'https://ocean.waimai.test.sankuai.com'
};
var API = {
  dev: {
    checkTextVersion: '/api/openapi/v1/package',
    fetchText: '/api/openapi/v1/text'
  },
  test: {
    checkTextVersion: '/api/openapi/v1/package_test',
    fetchText: '/api/openapi/v1/text_test'
  },
  prod: {
    checkTextVersion: '/api/openapi/v1/package',
    fetchText: '/api/openapi/v1/text'
  }
};
function checkUpdate(params, env) {
  if (env === void 0) {
    env = 'prod';
  }
  return __awaiter(this, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
      url = "".concat(HOST[env]).concat(API[env].checkTextVersion);
      return [2, post(url, params)];
    });
  });
}
function fetchText(params, env) {
  if (env === void 0) {
    env = 'prod';
  }
  return __awaiter(this, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
      url = "".concat(HOST[env]).concat(API[env].fetchText);
      return [2, post(url, params)];
    });
  });
}

var getDefaults = function () {
  return {
    namespaces: [],
    env: 'prod'
  };
};
var I18nOpenAPIBackend = function () {
  function I18nOpenAPIBackend(services, backendOptions, i18nextOptions) {
    this.init(services, backendOptions, i18nextOptions);
  }
  I18nOpenAPIBackend.prototype.getDefauleNs = function (i18nextOptions) {
    var defaultNS = (i18nextOptions || {}).defaultNS;
    if (typeof defaultNS === 'string') {
      return defaultNS;
    } else if (Array.isArray(defaultNS) && defaultNS.length > 0) {
      return defaultNS[0];
    }
    return '';
  };
  I18nOpenAPIBackend.prototype.normalizeOptions = function (i18nextOptions) {
    var namespaces = this.backendOptions.namespaces;
    var len = namespaces.length;
    var defaultNS = this.getDefauleNs(i18nextOptions);
    if (len === 1) {
      var curNamespace = namespaces[0];
      if (!curNamespace.name) {
        curNamespace.name = defaultNS;
      }
      return;
    }
    if (len > 1) {
      var isSetDefault = false;
      var namespaceNames = [];
      for (var _i = 0, namespaces_1 = namespaces; _i < namespaces_1.length; _i++) {
        var namespace = namespaces_1[_i];
        if (!namespace.name) {
          console.error('OpenAPIBackend parameter error: ensure that the name value in the namespace not empty');
          if (isSetDefault) {
            console.error('OpenAPIBackend parameter error: ensure that the name value in the namespace is unique');
            return;
          }
          isSetDefault = true;
          namespace.name = defaultNS;
        }
        if (namespaceNames.includes(namespace.name)) {
          console.error('OpenAPIBackend parameter error: ensure that the name value in the namespace is unique');
          return;
        }
        namespaceNames.push(namespace.name);
      }
    }
  };
  I18nOpenAPIBackend.prototype.init = function (services, backendOptions, i18nextOptions) {
    this.services = services;
    this.backendOptions = __assign(__assign({}, getDefaults()), backendOptions);
    this.normalizeOptions(i18nextOptions);
    this.type = 'backend';
  };
  I18nOpenAPIBackend.prototype.getCacheKey = function (projectId, namespaceId, language, namespace) {
    return "".concat(projectId, "_").concat(namespaceId, "_").concat(language, "_").concat(namespace);
  };
  I18nOpenAPIBackend.prototype.read = function (language, namespace, callback) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, env, namespaces, curNamespaceInfo, $owl, projectId, namespaceId, params, res, error_1, cacheKey, cachedText, cachedData, languagePackage, resText, error_2, error_3;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.backendOptions, env = _a.env, namespaces = _a.namespaces;
            curNamespaceInfo = namespaces.find(function (item) {
              return item.name === namespace;
            });
            if (!curNamespaceInfo) {
              return [2, callback(new Error('The space does not exist in the configuration'), null)];
            }
            $owl = this.services.$owl;
            projectId = curNamespaceInfo.projectId, namespaceId = curNamespaceInfo.namespaceId;
            params = {
              projectId: projectId,
              namespaceId: namespaceId,
              locale: language,
              onlyVersion: 0
            };
            _b.label = 1;
          case 1:
            _b.trys.push([1, 10,, 11]);
            res = void 0;
            _b.label = 2;
          case 2:
            _b.trys.push([2, 4,, 5]);
            return [4, checkUpdate(params, env)];
          case 3:
            res = _b.sent();
            return [3, 5];
          case 4:
            error_1 = _b.sent();
            $owl && $owl.setMetric('FEi18nBundleUpdateFailure', 1);
            $owl && $owl.addError("checkUpdate \u5F02\u5E38\uFF1A".concat(error_1.message));
            return [2, callback(error_1, null)];
          case 5:
            cacheKey = this.getCacheKey(projectId, namespaceId, language, namespace);
            if (res.packages && res.packages.length > 0) {
              cachedText = window.localStorage.getItem(cacheKey);
              cachedData = cachedText ? JSON.parse(cachedText) : {};
              languagePackage = res.packages[0];
              if (cachedData && cachedData.version && languagePackage.version === cachedData.version) {
                $owl && $owl.setMetric('FEi18nBundleCacheUsage', 1);
                return [2, callback(null, cachedData.kv)];
              }
            }
            resText = void 0;
            _b.label = 6;
          case 6:
            _b.trys.push([6, 8,, 9]);
            return [4, fetchText(params, env)];
          case 7:
            resText = _b.sent();
            return [3, 9];
          case 8:
            error_2 = _b.sent();
            $owl && $owl.setMetric('FEi18nBundleGetTextFailure', 1);
            $owl && $owl.addError("fetchText \u5F02\u5E38\uFF1A".concat(error_2.message || ''));
            return [2, callback(error_2, null)];
          case 9:
            $owl && $owl.setMetric('FEi18nBundleGetTextSuccess', 1);
            if (resText.version && resText.kv) {
              $owl && $owl.setMetric('FEi18nBundleUpdateSuccess', 1);
              window.localStorage.setItem(cacheKey, JSON.stringify(resText));
              return [2, callback(null, resText.kv)];
            } else {
              $owl && $owl.setMetric('FEi18nBundleEmpty', 1);
              return [2, callback(new Error('language package empty'), null)];
            }
          case 10:
            error_3 = _b.sent();
            $owl && $owl.addError("openapi read \u5F02\u5E38\uFF1A".concat(error_3.message));
            return [2, callback(error_3, null)];
          case 11:
            return [2];
        }
      });
    });
  };
  return I18nOpenAPIBackend;
}();
I18nOpenAPIBackend.type = 'backend';

export { I18nOpenAPIBackend as default };
